export default __webpack_public_path__ + "static/media/icon_delete.e2d5fa3f.svg";